import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const painPoints = ['Sleep hygiene lists feel like chores.', "Melatonin makes you groggy but doesn't stop the scrolling urge.", 'Phone-locking apps trigger binge-rebound behavior.'];
export function PainPoints() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800 relative border-y border-navy-700" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-99">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-100">
            Why What You've Tried{' '}
            <span className="text-red-400" data-id="element-101">Didn't Work</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-102">
            You don't lack discipline. You're just using the wrong tools to
            fight a biological response.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-103">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-navy-900 border border-navy-700 p-8 rounded-2xl flex flex-col items-center text-center space-y-4 hover:border-red-500/30 transition-colors" data-id="element-104">
              <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mb-2" data-id="element-105">
                <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-106" />
              </div>
              <p className="text-slate-300 font-medium text-lg leading-relaxed" data-id="element-107">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}